export const isCampaignActive = (campaign) => {
    const now = Date.now();
    const { startDate: start, endDate: end } = campaign;
    return !!(start && end && Number(start) <= now && Number(end) >= now);
};
